import React, { useRef, useEffect } from "react";
import Typewriter from "typewriter-effect/dist/core";
import "./TypewriterEffect.css";

const TypewriterText = () => {
  const typewriterRef = useRef(null);

  useEffect(() => {
    var typewriter_welcome = document.getElementById("typewriter_welcome");

    var typewriter = new Typewriter(typewriter_welcome, {
      loop: false,
    });

    typewriter.typeString("> bonsoir, <strong>$friend</strong>.").start();

    typewriter.changeCursor(" ");

    var typewriter_whoami = document.getElementById("typewriter_whoami");

    var typewriter2 = new Typewriter(typewriter_whoami, {
      loop: false,
      cursor: "",
    });

    setTimeout(() => {
      typewriter2.changeCursor("|");
      typewriter2
        .typeString("> I'm Andrei, a software developer.")
        .pauseFor(2500)
        .deleteChars(19)
        .typeString("statistics student @unipd.")
        .pauseFor(2500)
        .deleteChars(26)
        .typeString("physics and AI enthusiast.")
        .pauseFor(2500)
        .deleteChars(28)
        .typeString("curious.")
        .start();
    }, 3500);
  }, []);

  return (
    <div className="typewriter-container">
      <div
        id="typewriter_welcome"
        className="typewriter"
        ref={typewriterRef}></div>
      <div
        id="typewriter_whoami"
        className="typewriter"
        ref={typewriterRef}></div>
    </div>
  );
};

export default TypewriterText;
